import { ThemeColors } from '../../../../tokens/colors/types';

export const purple: ThemeColors['purple'] = {
  '20': '#EFEBF9',
  '30': '#C4B8EA',
  '50': '#7B61D1',
  '70': '#5335B6',
  '90': '#38247B',
};

export const blue: ThemeColors['blue'] = {
  '20': '#EBF5FA',
  '30': '#D4EAF7',
  '50': '#3398d9',
  '70': '#003399',
  '90': '#000e2a',
};

export const green: ThemeColors['green'] = {
  '20': '#E1F9F5',
  '30': '#E6F5E6',
  '50': '#1CB670',
  '70': '#3D8F5D',
  '90': '#146154',
};

export const orange: ThemeColors['orange'] = {
  '20': '#FEF4E7',
  '30': '#FFEACC',
  '50': '#FF9600',
  '70': '#DC5F0B',
  '90': '#965C08',
};

export const red: ThemeColors['red'] = {
  '20': '#FCE9E9',
  '30': '#FDE7EA',
  '50': '#F01C3D',
  '70': '#9B0000',
  '90': '#965C08',
};

export const neutral: ThemeColors['neutral'] = {
  '0': '#FFFFFF',
  '10': '#F5F5F5',
  '20': '#F7F7F7',
  '30': '#F2F2F2',
  '40': '#E6E6E6',
  '50': '#CBCBCB',
  '60': '#B2B2B2',
  '70': '#909090',
  '80': '#6F6F6F',
  '90': '#4C4C4C',
  '100': '#272727',
};
